import { type JSX } from "react";
import styles from "@/components/ClientOfferView.module.css";
import type { OfferSectionProps } from "@/components/offer/offerDocumentTypes";

const DEFAULT_EXCLUDED = [
  "Prace dodatkowe poza zakresem z tabeli kosztorysowej",
  "Zmiany wynikające z ukrytych wad podłoża po rozpoczęciu prac",
  "Koszty administracyjne i opłaty urzędowe",
];

export function IncludedExcludedSection(_offerData: OfferSectionProps): JSX.Element {
  return (
    <section className={styles.assumptions}>
      <div>
        <h2 className={styles.assumptionsHeading}>
          Czego oferta
          <br />
          nie obejmuje
        </h2>
      </div>
      <div className={styles.assumptionsList}>
        <p className={styles.assumptionsProse}>{DEFAULT_EXCLUDED.join(", ")}</p>
      </div>
    </section>
  );
}
